import {
  getComplianceProfile,
  useComplianceProfile,
} from '~/services/compliance';
import { useAppSelector } from '~/store/hooks/useAppSelector';
import { ProfileType } from '~/types/profile';

import { hasOrHadSubscription } from './helpers';

/**
 * Two independent axes: compliance must enable the feature for this mode AND
 * the user must have (or have had) a subscription to have anything to bill.
 * Pure version for declarative gates (SideBarItemType.checkAvailability).
 */
export const canAccessBillingHistory = (profile: ProfileType): boolean =>
  getComplianceProfile().billingHistory &&
  hasOrHadSubscription(profile.user_subscription?.status);

/** React-reactive version of canAccessBillingHistory for components. */
export const useCanAccessBillingHistory = (): boolean => {
  const { billingHistory } = useComplianceProfile();
  const status = useAppSelector(
    (state) => state.profile.user_subscription?.status,
  );
  return billingHistory && hasOrHadSubscription(status);
};
